
<div class="position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
  style="z-index: -1">
  <div class="container-fluid">
    <div class="row">
      <div class="col-6 auth-bg"></div>
      <div class="col-6"></div>
    </div>
  </div>
</div>


<div class="d-flex align-items-center justify-content-center" style="height: 100vh;">
  <mat-card appearance="raised" class="auth-card-body">
    <mat-card-content>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class="text-center">
              <span class="icon mb-auto">
                <svg width="70" height="70" viewBox="0 0 70 70" style="color: #f95c31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M31.33 50.815H24.33C23.9825 50.8077 23.6429 50.71 23.3447 50.5315C23.0464 50.353 22.7999 50.0999 22.6293 49.7971C22.4587 49.4942 22.3699 49.1522 22.3718 48.8046C22.3737 48.457 22.4661 48.116 22.64 47.815L33.31 29.685C33.4899 29.3978 33.7398 29.161 34.0363 28.9969C34.3328 28.8327 34.6661 28.7466 35.005 28.7466C35.3439 28.7466 35.6772 28.8327 35.9737 28.9969C36.2702 29.161 36.5201 29.3978 36.7 29.685L47.35 47.855C47.5239 48.156 47.6163 48.497 47.6182 48.8446C47.6201 49.1922 47.5313 49.5342 47.3607 49.8371C47.1901 50.1399 46.9436 50.393 46.6453 50.5715C46.3471 50.75 46.0075 50.8477 45.66 50.855H38.38V57.305H61.11L35.01 12.695L8.89 57.265H31.33V50.815Z"/>
                </svg>
              </span>
            </div>
            <div class="text-center">
              <div class="tg-font fw-bold"> ZestyPOS </div>
              <small class="text-secondary fst-italic">A single platform for all your restaurant's
              needs </small>
            </div>


            <div class="p-sm-2 mt-2" >
              <div class="h5 fw-bold mb-2">Sign Up Here !</div>

              <form nz-form [formGroup]="signUpForm" class="login-form" (ngSubmit)="submitForm()">
                <div class="row">
                  <div class="col-sm-6">
                    <nz-form-item class="mb-2">
                      <div class="w-100">
                        <nz-form-label nzRequired>First Name</nz-form-label>
                        <nz-form-control nzErrorTip="Please input OTP!">
                          <nz-input-group nzPrefixIcon="idcard" nzSize="large">
                            <input type="text" nz-input formControlName="firstName" placeholder="First Name" />
                          </nz-input-group>
                        </nz-form-control>
                      </div>
                    </nz-form-item>

                    <nz-form-item class="mb-2">
                      <div class="w-100">
                        <nz-form-label nzRequired>Mobile Number</nz-form-label>
                        <nz-form-control nzErrorTip="Please input Mobile Number!">
                          <nz-input-group nzPrefixIcon="phone" nzSize="large">
                            <input type="text" nz-input formControlName="mobileNumber" placeholder="Mobile Number" />
                          </nz-input-group>
                        </nz-form-control>
                      </div>
                    </nz-form-item>

                  </div>
                  <div class="col-sm-6">
                    <nz-form-item class="mb-2">
                      <div class="w-100">
                        <nz-form-label >Last Name</nz-form-label>
                        <nz-form-control >
                          <nz-input-group nzPrefixIcon="user" nzSize="large">
                            <input type="text" nz-input formControlName="lastName" placeholder="Last Name" />
                          </nz-input-group>
                        </nz-form-control>
                      </div>
                    </nz-form-item>

                    <nz-form-item class="mb-2">
                      <div class="w-100">
                        <nz-form-label nzRequired>OTP</nz-form-label>
                        <nz-form-control nzErrorTip="Please input OTP!">
                          <nz-input-group nzPrefixIcon="safety" nzSize="large">
                            <input type="text" nz-input formControlName="oneTimePassword" placeholder="OTP" />
                          </nz-input-group>
                        </nz-form-control>
                      </div>
                    </nz-form-item>

                  </div>
                </div>



                <nz-form-item class="mb-2">
                  <div class="w-100">
                    <nz-form-label >Address</nz-form-label>
                    <nz-form-control >
                      <nz-input-group nzPrefixIcon="tag" nzSize="large">
                        <textarea type="text" rows="1" nz-input formControlName="address" placeholder="Address" ></textarea>
                      </nz-input-group>
                    </nz-form-control>
                  </div>
                </nz-form-item>
                <nz-form-item class="mb-2">
                  <div class="w-100">
                    <nz-form-label nzRequired>Password</nz-form-label>
                    <nz-form-control nzErrorTip="Please input your Password!">
                      <nz-input-group nzPrefixIcon="lock" nzSize="large" [nzSuffix]="suffixTemplate">
                        <input [type]="passwordVisible ? 'text' : 'password'" nz-input formControlName="password"
                          placeholder="Password" />
                      </nz-input-group>
                      <ng-template #suffixTemplate>
                        <em nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" nzTheme="outline"
                        (click)="passwordVisible = !passwordVisible"></em>
                      </ng-template>
                    </nz-form-control>
                  </div>
                </nz-form-item>
                <nz-form-item class="mb-2">
                  <div class="w-100">
                    <nz-form-label nzRequired>Confirm Password</nz-form-label>
                    <nz-form-control [nzErrorTip]="errorTpl">
                      <nz-input-group nzPrefixIcon="lock" nzSize="large" [nzSuffix]="suffixTemplateC">
                        <input [type]="confirmPasswordVisible ? 'text' : 'password'" nz-input formControlName="confirmPassword"
                          autocomplete="false" placeholder="Confirm Password" />
                        <ng-template #errorTpl let-control>
                          @if (control.hasError('required')) {
                            Please confirm your password!
                          }
                          @if (control.hasError('confirm')) {
                            Two passwords that you enter is inconsistent!
                          }
                        </ng-template>
                        <ng-template #suffixTemplateC>
                          <i nz-icon [nzType]="confirmPasswordVisible ? 'eye-invisible' : 'eye'" nzTheme="outline"
                          (click)="confirmPasswordVisible = !confirmPasswordVisible"></i>
                        </ng-template>
                      </nz-input-group>
                    </nz-form-control>
                  </div>
                </nz-form-item>
                <button nz-button class="login-form-button mt-2 w-100" [nzType]="'primary'">
                  Sign Up
                </button>
              </form>

            </div>

          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>

</div>


